import { useEffect, useState } from 'react'

const DEFAULT_DELAY_MS = 300

export default function useDebouncedValue<T>(
  value: T,
  delay = DEFAULT_DELAY_MS
): T {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => clearTimeout(timer)
  }, [value, delay])

  return debouncedValue
}
